import { createSelector } from 'reselect'
import { isBoostrappedSelector } from 'selectors/app/base'
import storage from 'util/storage'
import selectIntegrationCredentialsByProvider from './selectIntegrationCredentialsByProvider'

export default createSelector(
  isBoostrappedSelector,
  selectIntegrationCredentialsByProvider,
  (isBootstrapped, integrationCredentialsByProvider) => {
    if (!isBootstrapped) return false

    return (
      !storage.get('showShopifyV2') ||
      (!!storage.get('showShopifyV2') &&
        !!integrationCredentialsByProvider.SHOPIFY)
    )
  }
)
